export const ProfileLoc = {
    companyInfo: {
        ru: 'Информация о компании',
        en: 'Company info',
    },
    newCompany: {
        ru: 'Новая компания',
        en: 'New company',
    },
    newTIN: {
        ru: 'Новый ИНН',
        en: 'New TIN',
    },
    newCity: {
        ru: 'Новый город',
        en: 'New city',
    },
    newAddress: {
        ru: 'Новый адрес',
        en: 'New address',
    },
    newFIO: {
        ru: 'Новое ФИО',
        en: 'New name',
    },
    newEmail: {
        ru: 'Новая почта',
        en: 'New email',
    },
    modalMessage: {
        ru: 'Заявка на изменение данных была отправлена вашему менеджеру',
        en: 'Request to change customer data has been sent to your manager',
    },
    changeContact: {
        ru: 'Изменить контактные данные',
        en: 'Change contact data',
    },
    changePhone: {
        ru: 'Отправить заявку на изменение номера телефона',
        en: 'Send a request to change phone number',
    },
    changeCompanyData: {
        ru: 'Отправить заявку на изменение данных',
        en: 'Send a request to change customer data',
    },
    changeButton: {
        ru: 'Изменить',
        en: 'Change',
    },
    sendButton: {
        ru: 'Отправить',
        en: 'Send',
    },
    newPhone: {
        ru: 'Новый телефон',
        en: 'New phone',
    },
    oldPassword: {
        ru: 'Старый пароль',
        en: 'Old Password',
    },
    newPassword: {
        ru: 'Новый пароль',
        en: 'New password',
    },
    successPasswordReset: {
        ru: 'Пароль успешно изменен',
        en: 'Password successfully updated',
    },
};
